var $doc = $(document),
    $window = $(window),
    $html = $("html"),
    $body = $("body"),
    $header = $("#layout_header");

(function($) {
    cssLoaded(function(){
        $body.removeClass("mod--preload");
        setTimeout(function () {
            $body.addClass("mod--loaded");
            $.getStyle("https://hello.myfonts.net/count/34fcbd");
        }, 300);
    });
})(jQuery);

if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
        if (!$html.hasClass("no-sw")) {
            navigator.serviceWorker.register('/sw.js').catch(function(e) {
                console.error('Error during service worker registration:', e);
            });
        } else {
            navigator.serviceWorker.getRegistrations().then(function(registrations) {
                for(let registration of registrations) {
                    registration.unregister()
                }
            });
        }
    });
}